import React from 'react';

const Footer = () => {
    return (
        <div className="text-center">
            <p> &copy; All rights reserved, Abid Nuri, {new Date().getFullYear()}</p>
        </div>
    );
};

export default Footer;